import React from 'react'
import IconBtn from './IconBtn'

const ConfirmationModal = ({modalData}) => {
  return (
    <div>
        <div className='w-11/12 max-w-[350px] rounded-lg border border-richblack-600 bg-stone-300 p-6 z-50 fixed left-[50%] top-[50%] -translate-x-1/2 -translate-y-1/2'>
            <p className='text-2xl font-semibold text-black'>
                {modalData.text1}
            </p>
            <p className='mt-3 mb-5 leading-6 text-richblack-600'>
                {modalData.text2}
            </p>
            <div className='flex items-center gap-x-4'>
                <IconBtn 
                    onclick={modalData?.btn1Handler}
                    text={modalData?.btn1Text}
                    />
                <button className='flex items-center bg-stone-300 cursor-pointer gap-x-2 rounded-md py-2 text-sm md:text-lg px-3 md:px-5 font-semibold text-richblack-900 undefined' onClick={modalData?.btn2Handler}>
                    {modalData?.btn2Text}
                </button>    
            </div>
        </div>

        <div className='fixed inset-0 z-10 !mt-0 grid place-items-center overflow-auto bg-white bg-opacity-10 backdrop-blur-sm over'></div>
      
    </div>
  )
}

export default ConfirmationModal
